import React from 'react'
import { Spinner } from '@telavita-core/react-design-kit'
import { SpinnerContainer } from './styles'
import { FC } from 'react'

export const LoadingSpinner: FC = () => {
  return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  )
}
